import { Component, ElementRef, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-customer-add-edit',
  templateUrl: './customer-add-edit.component.html',
  styleUrls: ['./customer-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CustomerAddEditComponent implements OnInit {

  userForm!:FormGroup;
  adminType!: any;
  hide:boolean = true;
  userId!:string;
  userData:any;
  constructor(
    private apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute
    
  ) { }

  ngOnInit(): void {
    this.formInit();
    this.getAdminType();
    this.userId = this.activateRoute.snapshot.params["id"];
    if(this.userId){
      this.getUserData();
    }
    this.validatePassword();
  }
  formInit(){
    this.userForm = new FormGroup({
      roleId: new FormControl('', [Validators.required]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      emailAddress: new FormControl('', [Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),]),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),]),
      password: new FormControl('', [Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]),
    })
  };
  getAdminType(){
    this.apiService.get('admin/role/get-consumer-role').subscribe((res:HttpResponse<any>)=>{
      if(res.body){
        this.adminType = res.body.role;
        setTimeout(() =>
          this.userForm.get("roleId")?.setValue(this.adminType?.roleId || null)
        );
      }
    })
  };
  getUserData(){
    this.apiService.get(`admin/user/get-user/${this.userId}`).subscribe((res:any)=> {
      if(res.body){
        this.userData = res?.body?.user;
        this.userForm.patchValue(res?.body?.user);
        this.userForm.patchValue({
          roleId: res?.body?.user?.role?.roleId
        })
      }
    })
  }
  editUser(){
    if(this.userForm.valid){   
      const {emailAddress, firstName, lastName, password, phoneNumber, roleId} = this.userForm.value;
    const payload = {
      assignedRole: [
        {
          roleId,
          subRoleId: [],
        },
      ],
      emailAddress,
      firstName,
      lastName,
      password,
      phoneNumber,
    };
      if(!payload?.password){
        delete payload.password;
      }
       if(!this.userId){
        this.apiService.post('admin/user/create-user', payload).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
       } else {
        this.apiService.post(`admin/user/update-user/${this.userId}`, payload).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
       }
    } else {
      this.userForm.markAllAsTouched();
    }
  };
  restrictSpace(event: any) {
    if (event.target.value.match(/\s/g)) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  };
  validatePassword(){
    const PasswordControl = this.userForm.get('password');
    if(!this.userId){
      PasswordControl.setValidators([Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')])
    } else {
      PasswordControl.setValidators([Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')])
    }
    PasswordControl.updateValueAndValidity();
  };
  
 generateStrongPassword() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
  let password = "";
  // Ensure at least one uppercase, one lowercase, one number, and one special character
  password += this.getRandomChar("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
  password += this.getRandomChar("abcdefghijklmnopqrstuvwxyz");
  password += this.getRandomChar("0123456789");
  password += this.getRandomChar("!@#$%^&*");

  // Fill the remaining characters randomly
  for (let i = 4; i < 10; i++) {
    password += this.getRandomChar(characters);
  }
  // Shuffle the password to ensure randomness of character types
  this.userForm.patchValue({ password: this.shuffleString(password)});
}

 getRandomChar(charSet: string) {
  const randomIndex = Math.floor(Math.random() * charSet.length);
  return charSet[randomIndex];
}

 shuffleString(str: string) {
  const arr = str.split('');
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr.join('');
}

}
